import { ReferenceField, ReferenceFieldProps } from "react-admin";
import BankNameField from "./BankNameField";

const BankReferenceField = (
  props: Omit<ReferenceFieldProps, "reference" | "children" | "source"> & {
    source?: string;
  }
) => (
  <ReferenceField
    source="bank_id"
    reference="banks"
    emptyText="N/A"
    link="show"
    {...props}
  >
    <BankNameField />
  </ReferenceField>
);
BankReferenceField.defaultProps = {
  source: "bank_id",
};

export default BankReferenceField;
